var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CButton',{attrs:{"color":"primary","size":"sm"},on:{"click":function($event){return _vm.$emit('viewProcedure')}}},[_vm._v("View")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }